
import { useState, useEffect } from 'react';
import OptimizedImage from '@/components/ui/optimized-image';

// Logos data
const allLogos = [
  { id: 1, name: 'Bits In Glass', logo: '/lovable-uploads/BitsInGlass.png', width: 120, height: 40 },
  { id: 2, name: 'StepSecurity', logo: '/lovable-uploads/StepSecurity.png', width: 120, height: 40 },
  { id: 3, name: 'Shiprocket', logo: '/lovable-uploads/Shiprocket.png', width: 120, height: 40 },
  { id: 4, name: 'Averlon', logo: '/lovable-uploads/Averlon.png', width: 120, height: 40 },
  { id: 5, name: 'Fractal', logo: '/lovable-uploads/Fractal.png', width: 120, height: 40 },
  { id: 6, name: 'Sprinto', logo: '/lovable-uploads/Sprinto.png', width: 120, height: 40 },
  { id: 7, name: 'Sun King', logo: '/lovable-uploads/SunKing.png', width: 120, height: 40 },
  { id: 8, name: 'Data Axle', logo: '/lovable-uploads/DataAxle.png', width: 120, height: 40 },
];

const LogosGrid = () => {
  const [visibleLogos, setVisibleLogos] = useState<typeof allLogos>([]);

  // Rotate logos
  useEffect(() => {
    // Initial set of logos
    setVisibleLogos(allLogos.slice(0, 8));
    
    // Rotate logos every 5 seconds
    const interval = setInterval(() => {
      setVisibleLogos((prev) => {
        const currentIds = new Set(prev.map(logo => logo.id));
        const remaining = allLogos.filter(logo => !currentIds.has(logo.id));
        const newLogos = [...remaining.slice(0, 8 - prev.length), ...prev.slice(0, Math.max(0, 8 - remaining.length))];
        return newLogos;
      });
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mt-6 pt-4 border-t border-gray-200">
      <p className="text-sm text-center text-cs-medium-grey mb-4">Averted hiring emergencies at:</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-4">
        {visibleLogos.slice(0, 4).map((logo) => (
          <div 
            key={logo.id}
            className="flex items-center justify-center h-12"
          >
            <OptimizedImage
              src={logo.logo}
              alt={logo.name}
              width={logo.width}
              height={logo.height}
              className="max-h-full max-w-full"
              loading="lazy"
            />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {visibleLogos.slice(4, 8).map((logo) => (
          <div 
            key={logo.id}
            className="flex items-center justify-center h-12"
          >
            <OptimizedImage
              src={logo.logo}
              alt={logo.name}
              width={logo.width}
              height={logo.height}
              className="max-h-full max-w-full"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogosGrid;
